<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    viewBox="0 0 20 20">
    <title :id="iconName">{{ iconName }} icon</title>
    <g
      :fill="iconColor"
      fill-rule="evenodd">
      <path
        d="M13.368 0H4.965c-.101 0-.198.04-.27.112L.112 4.695C.04 4.767 0 4.864 0 4.965v11.459c0 .21.171.382.382.382h8.927c.131 0 .253-.068.323-.178.07-.111.079-.25.021-.369-.323-.676-.486-1.392-.486-2.127 0-2.45 1.83-4.559 4.255-4.908.188-.027.328-.188.328-.378V.382c0-.21-.171-.382-.382-.382zM4.201 4.583H1.304l3.28-3.279v2.897c0 .211-.172.382-.383.382zm9.93 13.75c2.322 0 4.202-1.88 4.202-4.201 0-2.32-1.88-4.201-4.201-4.201-2.32 0-4.201 1.88-4.201 4.2 0 2.322 1.88 4.202 4.2 4.202zm-1.797-3.708c.075-.074.172-.111.27-.111.098 0 .196.037.27.111l.876.877V11.84c0-.21.171-.382.382-.382.21 0 .382.171.382.382v3.662l.875-.876c.15-.149.391-.149.54 0 .15.15.15.391 0 .54l-1.527 1.527c-.035.035-.078.064-.124.084-.093.038-.199.038-.292 0-.047-.02-.09-.048-.124-.084l-1.527-1.527c-.15-.15-.15-.39-.001-.54z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "download",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
}
</style>
